import { action } from 'typesafe-actions';
import {
  AddMemberActionTypes,
  CreateMemberRequest,
  OrganisationActionTypes,
  FetchOrgProfileParams,
  UpdateOrgProfileParams,
  EditMemberActionTypes,
  OrgTenant
} from './types';

export const fetchAddMemberInit = () =>
  action(AddMemberActionTypes.FETCH_ADD_MEMBER_INIT);

export const fetchAddMemberRequest = (req: CreateMemberRequest) =>
  action(AddMemberActionTypes.FETCH_ADD_MEMBER_REQUEST, req);

export const fetchAddMemberSuccess = (data: string) =>
  action(AddMemberActionTypes.FETCH_ADD_MEMBER_SUCCESS, data);

export const fetchAddMemberFailure = (errors: string) =>
  action(AddMemberActionTypes.FETCH_ADD_MEMBER_FAILURE, errors);

export const updateOrgProfileStart = (request: UpdateOrgProfileParams) =>
  action(OrganisationActionTypes.UPDATE_ORG_PROFILE_START, request);

export const updateOrgProfileSuccess = (Organisation: any) =>
  action(OrganisationActionTypes.UPDATE_ORG_PROFILE_SUCCESS, Organisation);

export const updateOrgProfileFailure = (error: any) =>
  action(OrganisationActionTypes.UPDATE_ORG_PROFILE_FAILURE, error);

export const fetchOrgProfileStart = (request: FetchOrgProfileParams) =>
  action(OrganisationActionTypes.FETCH_ORG_PROFILE_START, request);

export const fetchOrgProfileSuccess = (Organisation: any) =>
  action(OrganisationActionTypes.FETCH_ORG_PROFILE_SUCCESS, Organisation);

export const fetchOrgProfileFailure = (error: any) =>
  action(OrganisationActionTypes.FETCH_ORG_PROFILE_FAILURE, error);

export const fetchOrgTenantsStart = () =>
  action(OrganisationActionTypes.FETCH_ORG_TENANTS_START);

export const fetchOrgTenantsSuccess = (tenants: OrgTenant[]) =>
  action(OrganisationActionTypes.FETCH_ORG_TENANTS_SUCCESS, tenants);

export const fetchOrgTenantsFailure = (error: string) =>
  action(OrganisationActionTypes.FETCH_ORG_TENANTS_FAILURE, error);

export const clearOrgProfile = () =>
  action(OrganisationActionTypes.CLEAR_ORG_PROFILE);

export const setAddMemberModelOpenStart = (open: boolean) =>
  action(AddMemberActionTypes.OPEN_ADD_MEMBER_MODAL_START, open);

export const removeErrors = () => action(AddMemberActionTypes.REMOVE_ERROR);

export const updateNewRecordAddedFlag = (flag: boolean) =>
  action(AddMemberActionTypes.UPDATE_NEW_RECORD_ADDED_FLAG, flag);

export const setEditMemberModelOpenStart = (open: boolean) =>
  action(EditMemberActionTypes.OPEN_EDIT_MEMBER_MODAL_START, open);

export const setEditMemberInit = (data: any) =>
  action(EditMemberActionTypes.FETCH_EDIT_MEMBER_INIT, data);

export const setEditMemberRequest = (request: UpdateOrgProfileParams) =>
  action(EditMemberActionTypes.FETCH_EDIT_MEMBER_REQUEST, request);

export const setEditMemberSuccess = () =>
  action(EditMemberActionTypes.FETCH_EDIT_MEMBER_SUCCESS);

export const setEditMemberFailure = (error: any) =>
  action(EditMemberActionTypes.FETCH_EDIT_MEMBER_FAILURE, error);

export const updateOrgProfileUpdateFlag = (status: boolean) =>
  action(OrganisationActionTypes.UPDATE_ORG_PROFILE_UPDATE_FLAG, status);
